
  var path = 'scripts/segment-inputs-config/common/cottage-village-name/typeahead-item.tpl.jade';
  var html = "<!-- preventDefault нужен, чтобы не вызывать blur на инпуте--><a ng-mousedown=\"$event.preventDefault()\" ng-attr-title=\"{{match.model.name}}\" class=\"typeahead-item\"><div ng-bind-html=\"match.model.name\"></div><div ng-bind-html=\"match.model.address\" class=\"typeahead-item__address\"></div></a>";
  window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
  module.exports = path;
  